<template>
    <accordion-item show-open>
        <h2 slot="header">Assessments by Age</h2>
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__g-10">
                <h2 class="title">Comparison of Quantum Assessments by Age</h2>
                <div class="p-discount-rate-comparison__chart-select">
                    <option-filters name="ageGroupChartType">
                        <li :class="{'m-option-filters--active' : ageGroupChartType === 'bar'}"
                            @click="updateAgeGroupChartType('bar')">Bar Chart
                        </li>
                        <li :class="{'m-option-filters--active' : ageGroupChartType === 'line'}"
                            @click="updateAgeGroupChartType('line')">Line Chart
                        </li>
                    </option-filters>
                </div>
                <div class="flex-grid">
                    <div class="flex-grid__g-1"></div>
                    <div class="flex-grid__g-8">
                        <bar v-if="ageGroupChartType === 'bar'" :dataset="ageGroupBarDataset"
                             :labels="ageGroupBarLabels" :legend="false"></bar>
                        <linegraph v-if="ageGroupChartType === 'line'" :dataset="ageGroupLineDataset"
                                   :labels="ageGroupBarLabels" :legend="false"></linegraph>
                    </div>
                    <div class="flex-grid__g-1"></div>
                </div>
            </div>
        </div>
        <div class="u-text-center">
            <chart-legend
                    :columns="2"
                    :values="[
                    chosenRates[0],
                    chosenRates[1]
                    ]"
                    :legendWidth="chartLegendWidthTwo"
                    marginBottom="30"
            >
            </chart-legend>
        </div>
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
            <div class="flex-grid__g-10">
                <h2 class="title">Deceased's Age at Death</h2>
                <div class="p-discount-rate-comparison__chart-select">
                    <option-filters name="rateGroupChartType">
                        <li :class="{'m-option-filters--active' : rateGroupChartType === 'bar'}"
                            @click="updateRateGroupChartType('bar')">Bar Chart
                        </li>
                        <li :class="{'m-option-filters--active' : rateGroupChartType === 'line'}"
                            @click="updateRateGroupChartType('line')">Line Chart
                        </li>
                    </option-filters>
                </div>
                <div class="flex-grid">
                    <div class="flex-grid__g-1"></div>
                    <div class="flex-grid__g-8">
                        <bar v-if="rateGroupChartType === 'bar'" :dataset="rateGroupBarDataset" :labels="chosenRates"
                             :legend="false"></bar>
                        <linegraph v-if="rateGroupChartType === 'line'" :dataset="rateGroupLineDataset"
                                   :labels="chosenRates" :legend="false"></linegraph>
                    </div>
                    <div class="flex-grid__g-1"></div>
                </div>
            </div>
        </div>
        <div class="u-text-center">
            <chart-legend
                    :columns="3"
                    :values="ageLabels"
                    :legendWidth="chartLegendWidthThree"
                    marginBottom="30"
            >
            </chart-legend>
        </div>
        <div class="a-table--short-no-style">
            <table class="a-table u-full-width">
                <tr>
                    <th rowspan="2">
                        <h2>
                            Deceased's Age at Death
                        </h2>
                    </th>
                    <th rowspan="2" v-for="rate in chosenRates">
                        <h2>
                            Discount Rate {{ rate }}
                        </h2>
                    </th>
                    <th colspan="2">
                        <h2>Difference</h2>
                    </th>
                </tr>
                <tr>
                    <th>
                        <h2>&pound;</h2>
                    </th>
                    <th>
                        <h2>%</h2>
                    </th>
                </tr>
                <age-group-row v-for="row in rateGroupBarDataset" :row="row"></age-group-row>
            </table>
        </div>
    </accordion-item>
</template>

<script>
    import {mapGetters, mapState} from 'vuex';
    import AccordionItem from 'components/accordion/AccordionItem.vue';
    import AgeGroupRow from 'pages/discount-rate-comparison/components/tables/AgeGroupRow.vue';
    import Bar from 'pages/discount-rate-comparison/components/charts/Bar.vue';
    import Linegraph from 'pages/discount-rate-comparison/components/charts/Linegraph.vue';
    import _ from 'lodash';
    import OptionFilters from 'components/OptionFilters.vue';
    import ChartLegend from 'components/chart/Legend.vue';

    export default {
        name: 'assessments-by-age',
        components: {
            AccordionItem,
            AgeGroupRow,
            Bar,
            Linegraph,
            OptionFilters,
            ChartLegend
        },
        data() {
            return {
                ageGroupChartType: "bar",
                rateGroupChartType: "bar",
            }
        },
        computed: {
            ...mapState('discountRateComparison', [
                'chosenRates',
            ]),
            ...mapGetters('discountRateComparison', [
                'ageGroupGraph',
                'rateGroupGraph',
            ]),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            chartLegendWidthTwo() {
                switch (true) {
                    case this.theCurrentWidth <= 700:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 900:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 1024:
                        return 50;
                        break;
                    default:
                        return 40;
                }
            },
            chartLegendWidthThree() {
                switch (true) {
                    case this.theCurrentWidth <= 700:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 900:
                        return 90;
                        break;
                    case this.theCurrentWidth <= 1024:
                        return 70;
                        break;
                    default:
                        return 60;
                }
            },
            ageGroupBarLabels: {
                get() {
                    return _.keys(this.ageGroupGraph(this.chosenRates[0]));
                },
            },
            ageGroupBarDataset: {
                get() {
                    let groups = this.chosenRates;
                    let bars = _.zip.apply(_, [groups, ["#45BFFC", "#3DF2C3"]]);
                    let result = _.map(bars, (bar) => {
                        if (!bar[0]) {
                            return;
                        }

                        let data = _.values(this.ageGroupGraph(bar[0]));
                        if (data.length !== 2) {
                            data.push(0);
                        }
                        return {
                            label: bar[0],
                            xAxisID: 'xAxisLabels',
                            backgroundColor: bar[1],
                            borderWidth: 0,
                            data: data,
                        }
                    });

                    return _.compact(result);
                }
            },
            ageGroupLineDataset: {
                get() {
                    let groups = this.chosenRates;
                    let lines = _.zip.apply(_, [groups, ["#45BFFC", "#3DF2C3"]]);
                    let result = _.map(lines, (line) => {
                        if (!line[0]) {
                            return;
                        }

                        return {
                            label: line[0],
                            backgroundColor: "transparent",
                            borderColor: line[1],
                            pointBorderColor: line[1],
                            pointBackgroundColor: line[1],
                            borderWidth: 0,
                            data: _.values(this.ageGroupGraph(line[0])),
                        }
                    });

                    return _.compact(result);
                }
            },
            rateGroupBarDataset: {
                get() {
                    let groups = _.map(this.rateGroupGraph, (value, key) => [key, value]);
                    let rates = this.chosenRates;
                    let bars = _.zip.apply(_, [groups, [
                        '#45BFFC',
                        '#3DF2C3',
                        '#CD5CD8',
                        '#EB1458',
                        '#7DD3F4',
                        '#94F7DB',
                        '#E18FEF',
                        '#F94B8A',
                        '#4A89E5',
                        '#EA7A68',
                        '#9A4CD9',
                        '#BF104F',
                        '#422960',
                        '#007180',
                        '#2ECE9D'
                    ]]).map(bar => {
                        if (!bar[0]) {
                            return bar;
                        }
                        rates.forEach(rate => {
                            if (!bar[0][1][rate]) {
                                bar[0][1][rate] = 0;
                            }
                        });
                        return bar;
                    });

                    let result = _.map(bars, (bar) => {
                        if (!bar[0]) {
                            return;
                        }

                        return {
                            label: bar[0][0],
                            backgroundColor: bar[1],
                            borderWidth: 0,
                            data: _.values(bar[0][1]),
                        }
                    });

                    return _.compact(result);
                }
            },
            rateGroupLineDataset: {
                get() {
                    let groups = _.map(this.rateGroupGraph, (value, key) => [key, value]);
                    let bars = _.zip.apply(_, [groups, [
                        '#45BFFC',
                        '#3DF2C3',
                        '#CD5CD8',
                        '#EB1458',
                        '#7DD3F4',
                        '#94F7DB',
                        '#E18FEF',
                        '#F94B8A',
                        '#4A89E5',
                        '#2ECE9D',
                        '#9A4CD9',
                        '#BF104F',
                        '#422960'
                    ]]);

                    let result = _.map(bars, (bar) => {
                        if (!bar[0]) {
                            return;
                        }

                        return {
                            label: bar[0][0],
                            backgroundColor: "transparent",
                            pointBackgroundColor: bar[1],
                            borderColor: bar[1],
                            pointBorderColor: bar[1],
                            data: _.values(bar[0][1]),
                            borderWidth: 0,
                        }
                    });

                    return _.compact(result);
                }
            },
            ageLabels() {
                return this.rateGroupBarDataset.map(row => row.label + " - " + (parseInt(row.label, 10) + 5));
            },
        },
        methods: {
            updateAgeGroupChartType(type) {
                this.ageGroupChartType = type;
            },
            updateRateGroupChartType(type) {
                this.rateGroupChartType = type;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// AssessmentsByAge.vue?de8002ce